module.exports = __webpack_public_path__ + "static/media/sidd_logo3.3d268717.png";